interface LogDisplayProps {
  lines: string[];
  animated?: boolean;
}

function colorizeLogLine(line: string): JSX.Element {
  // Timestamp pattern
  const tsMatch = line.match(/^(\d{4}-\d{2}-\d{2}T[\d:]+Z)\s(.*)$/);
  if (tsMatch) {
    return (
      <>
        <span className="text-log-timestamp">{tsMatch[1]}</span>{' '}
        <span className="text-log-text">{tsMatch[2]}</span>
      </>
    );
  }
  if (line.includes('ERROR') || line.includes('ECONNREFUSED') || line.includes('failed') || line.includes('aborted')) {
    return <span className="text-log-error">{line}</span>;
  }
  if (/^\d+/.test(line) || line.includes('attempt')) {
    return <span className="text-log-number">{line}</span>;
  }
  return <span className="text-log-text">{line}</span>;
}

export default function LogDisplay({ lines, animated = false }: LogDisplayProps) {
  return (
    <div className="bg-log-bg rounded-md p-4 font-mono text-sm leading-relaxed overflow-x-auto">
      {lines.map((line, i) => (
        <div
          key={i}
          className={`whitespace-pre ${animated ? 'animate-fade-in' : ''}`}
          style={animated ? { animationDelay: `${i * 0.08}s`, opacity: 0, animationFillMode: 'forwards' } : {}}
        >
          {colorizeLogLine(line)}
        </div>
      ))}
    </div>
  );
}
